<template>
  <div>
    <Modal v-model="newBillOfLadingModal" :title="$t('key1004093')" width="1000" :transfer="false" class-name="newBillOfLadingStyle"
      :mask-closable="false" @on-visible-change="newBillOfLadingChange">
      <Form ref="newBillOfLadingForm" :model="newBillOfLadingForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
        <!--基本信息-->
        <Card :bordered="false" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1000929') }}</h2>
          </template>
          <Row style="width: 95%">
            <Col :span="24">
              <Form-item class="radio_styles" :label="$t('key1004094')" prop="storageType">
                <RadioGroup v-model="newBillOfLadingForm.storageType" @on-change="storageTypeChange">
                  <Radio v-for="item in storageTypeList" :key="item.value" :label="item.value">{{ item.name }}</Radio>
                </RadioGroup>
              </Form-item>
            </Col>
            <Col :span="newBillOfLadingForm.storageType === 3 ? 12 : 8">
              <Form-item :label="labelName + '：'" prop="ymsWarehouseId">
                <Select v-model="newBillOfLadingForm.ymsWarehouseId" filterable :placeholder="placeholderName">
                  <Option v-for="item in warehousesList" :value="item.ymsWarehouseId">{{ item.name }}</Option>
                </Select>
              </Form-item>
            </Col>
            <Col :span="newBillOfLadingForm.storageType === 3 ? 12 : 16">
              <Form-item :label="$t('key1004095')" prop="merchantType">
                <RadioGroup v-model="newBillOfLadingForm.merchantType">
                  <Radio class="mr12" v-for="item in merchantTypeList" :disabled="newBillOfLadingForm.storageType === 3"
                    :key="item.value" :label="item.value" style="top: 0px; font-size: 13px;">{{ item.name }}</Radio>
                </RadioGroup>
                <template v-if="newBillOfLadingForm.storageType !== 3 && newBillOfLadingForm.merchantType !== 3">
                  <commonRemoteSelect
                    ref="merchantSelect"
                    :transfer="false"
                    class="ml15 width_200"
                    v-model="newBillOfLadingForm.vestMerchantId"
                    :request-fn="getMerchantPageList"
                    :extra-params="merchantSearchParams"
                    :debounceTime="1000"
                    :placeholder="$t('key1004096')"
                    :propsMap="{value: 'ymsMerchantId', label: 'ymsMerchantId'}"
                  />
                </template>
              </Form-item>
            </Col>
            <Col :span="12" v-if="newBillOfLadingForm.storageType === 3">
              <Form-item :label="$t('key1004097')" prop="thirdPickupOrderNumber">
                <Input v-model.trim="newBillOfLadingForm.thirdPickupOrderNumber" :placeholder="$t('key1004098')" clearable></Input>
              </Form-item>
            </Col>
            <Col :span="12">
              <Form-item :label="$t('key1001495')" prop="remark">
                <Input
                  type="textarea"
                  :showWordLimit="true"
                  :maxlength="200"
                  :autosize="{ minRows: 4, maxRows: 8}"
                  v-model.trim="newBillOfLadingForm.remark">
                </Input>
              </Form-item>
            </Col>
          </Row>
        </Card>
        <!--明细信息-->
        <Card :bordered="false" dis-hover>
          <template #title>
            <h2 class="title_box">{{ $t('key1004100') }}</h2>
          </template>
          <div class="mb15 flex align-items-center">
            <Button type="primary" class="mr15" :disabled="addProductsDisabled"
              @click="$refs['addBillOfLadingGoodsModal'].initAddBillOfLadingGoodsData(newBillOfLadingForm)">{{ $t('key1004101') }}</Button>
            <Button type="error" class="mr15" :disabled="selectTableData.length === 0" @click="deleteProductBtn('all')">{{ $t('key1002406') }}</Button>
          </div>
          <Table
            ref="selection"
            highlight-row
            border
            :no-data-text="$t('key1004099')"
            max-height="300"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="tableData"
            @on-selection-change="getSelectValue">
            <!--操作数量-->
            <template #outOfStockQuantity="{row, index}">
              <InputNumber
                controls-outside
                :max="99999999"
                :min="1"
                style="width: 150px; text-align: center"
                :formatter="value => `${parseInt(value)}`"
                v-model.trim="tableData[index].quantity">
              </InputNumber>
            </template>
          </Table>
        </Card>
      </Form>
      <template #footer>
        <Button @click="newBillOfLadingModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" :disabled="tableData.length <=0 || newBillOfLadingTalg" @click="newBillOfLadingBtn">{{ $t('key1000555') }}</Button>
      </template>
    </Modal>
    <!--添加商品弹窗-->
    <addBillOfLadingGoodsModal ref="addBillOfLadingGoodsModal" @updateProductsData="updateProductsData"/>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {commonLocalStorage, getAllYmsWarehouseData, getDataSetBatchList, getEnumList} from "@/utils/common";
import commonRemoteSelect from "@/components/common/commonRemoteSelect.vue";
import addBillOfLadingGoodsModal from "@/views/yms/components/collectionManage/addBillOfLadingGoodsModal.vue";

export default {
  name: 'newBillOfLadingModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      platformSelfOperatedProduct: false,
      newBillOfLadingModal: false,
      newBillOfLadingForm: {
        merchantType: 3, // 归属商户类型 1供应商 2分销商 3运营
        remark: '',
        storageType: 3, // 入库类型  1供应商集货 2供应商备货 3自营入库 4其他入库
        thirdPickupOrderNumber: '', // 三方提单号
        vestMerchantId: null, // 归属商户
        ymsWarehouseId: null
      },
      ruleValidate: {
        ymsWarehouseId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004085'), trigger: 'change'}
        ],
        merchantType: [
          {required: true, type: 'number', message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004086'), trigger: 'change'}
        ],
      },
      warehousesList: [],
      enumData: [],
      tableColumns: [
        {
          type: 'selection',
          width: 70,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 280,
          key: 'goodsInfo',
          align: 'left',
          render: (h, params) => {
            let imagePath = params.row.primaryImage;
            let supplierSpu = params.row.supplierSpu;
            let ymsSpu = params.row.ymsSpu;
            let name = params.row.name;
            let list = [
              v.tableImg(h, params, null, imagePath),
              h('div', {class: 'flex flex-direction ml10'}, [
                h('div', [
                  h('Alink', {
                    props: {
                      linkName: name,
                      textAlign: 'left',
                      AlinkClass: 'ellipsis_1'
                    },
                    on: {
                      AlinkBtn: () => {
                        const {href} = v.$router.resolve({
                          path: '/productDetails',
                          query: {
                            type: 'look',
                            productId: params.row.ymsProductId
                          }
                        });
                        window.open(href, '_blank');
                      }
                    }
                  }),
                ]),
                [
                  h('p', {class: 'mt5'}, 'YMSSPU：' + ymsSpu),
                  h('p', {class: 'mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000600') + supplierSpu),
                ]
              ])
            ];
            return h('div', {class: 'flex ptb10'}, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          minWidth: 240,
          key: 'skuInfo',
          align: 'left',
          render: (h, params) => {
            let ymsSku = params.row.ymsSku;
            let supplierSku = params.row.supplierSku;
            let productGoodsSpecifications = params.row.productGoodsSpecifications || [];
            let spec = productGoodsSpecifications.map(i => i.value).join('、') || '';
            let list = [
              h('div', {class: 'flex flex-direction ml10'}, [
                h('div', [
                  h('p', {class: 'mt5'}, 'YMSSKU：' + ymsSku),
                  h('p', {class: 'mt5'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003976') + supplierSku),
                  h('p', {class: 'color-green'}, spec)
                ])
              ])
            ];
            return h('div', {class: 'flex ptb10'}, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004087'),
          key: 'quantity',
          align: 'center',
          minWidth: 180,
          slot: 'outOfStockQuantity'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'quantity',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: true,
                    clickFn: () => {
                      v.deleteProductBtn('single', params.row.ymsProductGoodsId)
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        },
      ],
      tableData: [],
      selectTableData: [],
      newBillOfLadingTalg: false,
    }
  },
  computed: {
    labelName() {
      return this.newBillOfLadingForm.storageType === 3 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004088') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004089');
    },
    placeholderName() {
      return this.newBillOfLadingForm.storageType === 3 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004090') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004091');
    },
    // 入库类型
    storageTypeList() {
      const ENUM_KEY = 'StorageTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      if (this.platformSelfOperatedProduct) {
        list = list.filter((item) => [3, 4].includes(item.value));
      } else {
        list = list.filter((item) => item.value === 4);
      }
      return list;
    },
    // 货主
    merchantTypeList() {
      const ENUM_KEY = 'MerchantTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      if (!this.platformSelfOperatedProduct) {
        list = list.filter((item) => item.value !== 3);
      } else {
        if (this.newBillOfLadingForm.storageType === 3) {
          list = list.filter((item) => item.value === 3);
        }
      }
      return list;
    },
    addProductsDisabled() {
      return this.newBillOfLadingForm.storageType === 4 &&
        ([1, 2].includes(this.newBillOfLadingForm.merchantType) &&
          !this.newBillOfLadingForm.vestMerchantId);
    },
    merchantSearchParams() {
      let obj = {};
      switch (this.newBillOfLadingForm.merchantType) {
        // 供应商
        case 1:
          obj = {
            createdEndTime: null,
            createdStartTime: null,
            emails: [],
            mobiles: [],
            orderBy: "createdTime",
            supplierAuditStatus: 2,
            supplierStatus: 1,
            upDown: "down",
            ymsMerchantIds: [],
          }
          break;
        // 分销商
        case 2:
          obj = {
            distributorAuditStatus: null,
            distributorMerchantGradeId: null,
            distributorMerchantGroupId: null,
            emails: [],
            labelNames: [],
            mobiles: [],
            registerEndTime: null,
            registerSource: null,
            registerStartTime: null,
            ymsMerchantIds: [],
          };
          break;
      }
      return obj;
    }
  },
  methods: {
    // 初始化数据
    async initNewBillOfLadingData() {
      this.optionBtnWidth = [];
      let enumKeyList = [
        'StorageTypeCoreEnum',
        'MerchantTypeCoreEnum'
      ];
      this.enumData = await getDataSetBatchList(enumKeyList);
      let warehousesData = await getAllYmsWarehouseData();
      this.warehousesList = warehousesData.filter((item) => item.status === 1);
      let saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      this.platformSelfOperatedProduct = Number(saasConfigurationItems?.platformSelfOperatedProductModelSaas) === 1;
      if (this.platformSelfOperatedProduct) {
        this.newBillOfLadingForm.storageType = 3; // 自营入库
      } else {
        this.newBillOfLadingForm.storageType = 4;
      }
      this.newBillOfLadingModal = true;
    },
    // 确定按钮
    newBillOfLadingBtn() {
      this.$refs['newBillOfLadingForm'].validate(valid => {
        if (valid) {
          let quantityFlag = this.tableData.some((item) => item.quantity <= 0);
          if (quantityFlag) {
            this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004092'));
            return false;
          }
          let query = {
            createYmsPickupOrderDetailBos: [],
            ...this.newBillOfLadingForm
          }
          this.tableData.forEach(item => {
            query.createYmsPickupOrderDetailBos.push({
              quantity: item.quantity,
              ymsProductGoodsId: item.ymsProductGoodsId
            });
          });
          this.newBillOfLadingTalg = true;
          this.axios.post(api.post_ymsPickupOrder_createYmsPickupOrder, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              this.newBillOfLadingTalg = false;
              this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488'));
              this.newBillOfLadingModal = false;
              this.$emit('updateData');
            } else {
              this.newBillOfLadingTalg = false;
            }
          });
        }
      });
    },
    // 获取列表勾选的数据
    getSelectValue(value) {
      this.selectTableData = value;
    },
    // 监听弹窗
    newBillOfLadingChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.$refs['merchantSelect']?.clearOptions();
          this.$refs['newBillOfLadingForm'].resetFields();
        });
        this.newBillOfLadingForm.vestMerchantId = null;
        this.tableData = [];
        this.newBillOfLadingTalg = false;
      }
    },
    // 切换入库类型
    storageTypeChange(value) {
      switch (value) {
        case 3:
          this.newBillOfLadingForm.merchantType = 3;
          break;
        case 4:
          this.newBillOfLadingForm.merchantType = 1;
          break;
      }
    },
    // 获取商户数据
    getMerchantPageList(params) {
      let url = this.newBillOfLadingForm.merchantType === 1 ?
        api.post_ymsSupplierMerchant_query : api.post_ymsDistributorMerchant_query;
      return this.axios.post(url, params);
    },
    // 更新添加货品
    updateProductsData(data) {
      let newData = [...this.tableData, ...data];
      this.tableData = newData.reduce((acc, curr) => {
        const existingItem = acc.find(item => item.ymsProductGoodsId === curr.ymsProductGoodsId);
        if (existingItem) {
          existingItem.quantity += curr.quantity;
        } else {
          acc.push(curr);
        }
        return acc;
      }, []);
    },
    // 移出商品
    deleteProductBtn(type, ymsProductGoodsId) {
      if (type === 'single') {
        this.tableData = this.tableData.filter(item => item.ymsProductGoodsId !== ymsProductGoodsId);
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
      } else {
        const selectedIds = new Set(this.selectTableData.map(item => item.ymsProductGoodsId));
        this.tableData = this.tableData.filter(item => !selectedIds.has(item.ymsProductGoodsId));
        this.selectTableData = [];
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000779'));
      }
    }
  },
  watch: {
    'newBillOfLadingForm.merchantType'() {
      this.$nextTick(() => {
        this.$refs.merchantSelect?.clearOptions();
        this.newBillOfLadingForm.vestMerchantId = null;
      });
    },
    'newBillOfLadingForm.vestMerchantId': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.tableData = [];
        }
      },
      deep: true
    }
  },
  components: {
    commonRemoteSelect,
    addBillOfLadingGoodsModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .newBillOfLadingStyle {
  .title_box {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }

  .ivu-card-head {
    padding: 14px 0;
  }

  .ivu-card-body {
    padding: 10px 0;

    .radio_styles .ivu-radio-wrapper {
      font-size: 12px;
    }

    .ivu-input-number-input {
      text-align: center;
    }
  }
}
</style>
